
namespace Gordic.Pod.Dialogs {
    
	/**
	* Dialog elektrolnického podání
	*
	* @author  David Šebesta
	* @date    01.08.2018
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
    export function EvidenceElPodaniDlg(
		parentContent: GContent,
		opt: {
			/** identifikátor */
            IxbArray: string[]
            PouzePrehled: boolean
		},
		ModOtevreni?: Gordic.Global.Enums.ModOtevreni
	): JQueryPromise<undefined> {

		const options = {
            ID: "PODEvidenceElPodani#",
            IxbArray: opt ? opt.IxbArray : undefined,
            PouzePrehled: opt ? opt.PouzePrehled : undefined,
		};

		const deferred = $.Deferred();
		const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

		let isValid = true;

		if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.GEvidenceElPodaniDlg', ModOtevreni, options);
		} else {
			deferred.reject();
		}

		return deferred.promise();
	}

    /**
	* SeznamDokumentuASpisu
	*
	* @author  David Šebesta
	* @date    01.08.2018
	*
	* @param   parentContent                        The content.
	* @param   ModOtevreni                    mod otevreni dialogu.
	* @return  .
	*/
    export function DokumentyASpisy(
        parentContent: GContent,
        opt?: {
            SubTask?: Pod.WebControls.Lists.DokumentyASpisySSDSubTask
        },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const options = $.extend({
            ID: "PODDokumentyASpisy#",
        }, opt);

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.Lists.DokumentyASpisy', ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    /**
     * Otevře okno pro zadání úložného místa
     *
     * @author  JSindelka
     * @date    7.1.2019
     *
     * @param {gcontent} parentContent The content.
     * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
     * @param {!object} opt Parametry dialogu.
     * @returns {JQueryPromise<undefined>} Promise.
     */
    export function OpenPotvrzeniODoruceniDlg(
        parentContent: GContent,
        opt?: { IdEntity: string },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<boolean | undefined> {
        const options = {
            Id: "PotvrzeniODoruceniDlg#",
            IdEntity: opt ? opt.IdEntity : ""
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.PotvrzeniODoruceniDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    /**
 * Otevře okno opravy metadt overeni el. podání
 *
 * @author  JSindelka
 * @date    20.1.2020
 *
 * @param {gcontent} parentContent The content.
 * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
 * @param {!object} opt Parametry dialogu.
 * @returns {JQueryPromise<undefined>} Promise.
 */
    export function OpravaMetadatOvereniDlg(
        parentContent: GContent,
        opt?: { Ixp: string },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<boolean | undefined> {
        const options = {
            Id: "OpravaMetadatOvereniDlg#",
            Ixp: opt.Ixp ? opt.Ixp : ""
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        if (!ModOtevreni) ModOtevreni = Gordic.Global.Enums.ModOtevreni.showModalWindow;
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;
        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.OpravaMetadatOvereniDlg', ModOtevreni, options, windowParams)
                .done(function (ret) {
                    if (ret == true)
                    {
                        parentContent.dialogs.alert("jres:23900175") //RC 23900175 : Aktualizace ověření byla provedena.
                        return true;
                    }
                })
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    export function HromadnaOpravaMetadatOvereniDlg(
        parentContent: GContent,
        opt?: {},
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Gordic.Pod.Interface.GHromadnaOpravaMetadatOvereniDto> {
        const options = {
            Id: "HromadnaOpravaMetadatOvereniDlg#"
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        if (!ModOtevreni) ModOtevreni = Gordic.Global.Enums.ModOtevreni.showModalWindow;
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;
        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.HromadnaOpravaMetadatOvereniDlg', ModOtevreni, options, windowParams)
                .done(function (ret) {
                    if (ret)
                    {
                        return ret;
                    }
                })
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    /**
 * Otevře okno pro zadání úložného místa
 *
 * @author  JSindelka
 * @date    7.1.2019
 *
 * @param {gcontent} parentContent The content.
 * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
 * @param {!object} opt Parametry dialogu.
 * @returns {JQueryPromise<undefined>} Promise.
 */
    export function ElPodaniZNosiceDlg(
        parentContent: GContent,
        opt?: { IdEntity: string },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<boolean | undefined> {
        const options = {
            Id: "ElPodaniZNosiceDlg#",
            IdEntity: opt ? opt.IdEntity : ""
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;
        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.ElPodaniZNosiceDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }


    /**
     * Otevře okno pro zadání úložného místa
     *
     * @author  JSindelka
     * @date    7.1.2019
     *
     * @param {gcontent} parentContent The content.
     * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
     * @param {!object} opt Parametry dialogu.
     * @returns {JQueryPromise<undefined>} Promise.
     */
    export function OdeslaniPotvrzeniODoruceniDlg(
        parentContent: GContent,
        opt?: { IdEntity: string },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<boolean | undefined> {
        const options = {
            Id: "OdeslaniPotvrzeniODoruceniDlg#",
            IdEntity: opt ? opt.IdEntity : ""
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;

        Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.OdeslaniPotvrzeniODoruceniDlg', ModOtevreni, options, windowParams);
  
        return deferred.promise();
    }

    /**
  * GPodaniOpravaPisemnostiDlg
  *
  * @author  David Šebesta
  * @date    29.05.2019
  *
  * @param   parentContent                        The content.
  * @param   ModOtevreni                    mod otevreni dialogu.
  * @return  .
  */
    export function PodaniOpravaPisemnostiDlg(
        parentContent: GContent,
        opt?: {
            Ixp: string,
            ModFormu?: Interface.ModFormuPodaniEnum,
            IDZpravy?: string,
            TypPid?: Wfl.Interface.TypPid,
            DataPosty?: Wfl.Interface.GWflvpdaDto
            PredplneniPrideleni?: Wfl.Interface.GSuFunRefDto
        },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const options = {
            ID: "PODPodaniOpravaPisemnostiDlg#",
            Ixp: opt.Ixp ? opt.Ixp:undefined,
            ModFormu: opt.ModFormu ? opt.ModFormu :  Interface.ModFormuPodaniEnum.NovePodani,
            IDZpravy: opt.IDZpravy ? opt.IDZpravy : undefined,
            TypPid: opt.TypPid ? opt.TypPid : Wfl.Interface.TypPid.neurceno,
            DataPosty: opt.DataPosty ? opt.DataPosty : undefined,
            PredplneniPrideleni: opt.PredplneniPrideleni ? opt.PredplneniPrideleni : undefined
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;

        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.GPodaniOpravaPisemnostiDlg', ModOtevreni, options);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }


        /**
        * AntivirInfoDlg
        *
        * @author  David Šebesta
        * @date    29.05.2019
        *
        * @param   parentContent                        The content.
        * @param   ModOtevreni                    mod otevreni dialogu.
        * @return  .
        */
    export function AntivirInfoDlg(
        parentContent: GContent,
        opt?: {
           },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

        const options = {
            };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        let isValid = true;
        if (isValid)
        {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Pod.WebControls.AntivirInfoDlg', ModOtevreni, options);
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    /**
   * Otevře dialog příloh podávaného dokumentu
   *
   * @author  dSebesta
   *
   * @param {gcontent} parentContent The content.
   * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
   * @param {!object} opt Parametry dialogu.
   * @param {!string} opt.SeznamPriloh GPrilohyPodavanehoDokumentuSeznamDto[].
   */
    export function GPrilohyPodavanehoDokumentuDlg(input: Gordic.Gui.Dialogs.OpenDialogParams<{ SeznamPriloh: Gordic.Pod.WebControls.GPrilohyPodavanehoDokumentuSeznamDto[], PocetInicacnichRadku:number|undefined }>
    ) {
        return Gordic.Gui.Dialogs.buildDialog<{ SeznamPriloh: Gordic.Pod.WebControls.GPrilohyPodavanehoDokumentuSeznamDto[], PocetInicacnichRadku: number | undefined  }, { SeznamPriloh: Gordic.Pod.WebControls.GPrilohyPodavanehoDokumentuSeznamDto[] } | undefined>({
            dialogName: 'Gordic.Pod.WebControls.GPrilohyPodavanehoDokumentuDlg',
            openDialogParams: input
        });
    }
}